import type { BaseKeyFunction } from "../../../../../lib/types/baseKeyFunction";

export type KeyCommunitiesStripeConnectStatusProps = {
  id: number;
};

export const keyCommunitiesStripeConnectStatus: BaseKeyFunction<
  KeyCommunitiesStripeConnectStatusProps
> = ({ id }) => ["communities-stripe-connect-status", id.toString()];
